var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "#5C5C5C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1623 0H16.9197L10.8955 6.88526L17.9825 16.2545H12.4335L8.08726 10.5721L3.1142 16.2545H0.355099L6.79857 8.88999L0 0H5.68992L9.61852 5.19395L14.1623 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXDark);
export default __webpack_public_path__ + "static/media/x-dark.edf37a8848034c9c50b02f506b94f3a2.svg";
export { ForwardRef as ReactComponent };